module.exports = __webpack_public_path__ + "assets/img/logo-frame-tablet.c81b2575.png";